import React from 'react';
import Typography from '@mui/material/Typography';
import { jobIconStatusMap, jobStatusColorMap } from './utils';
import { capitalize } from '../../utils/strings';

const JobCountsBar = ({
  jobCounts,
  statusTextMap,
}: {
  jobCounts: any;
  statusTextMap?: Record<string, string>;
}) => {
  if (!jobCounts) {
    return null;
  }

  const totalJobs = Object.values(jobCounts).reduce((acc, val) => {
    // @ts-ignore
    acc += val;
    return acc;
  }, 0);

  const jobPercentages = Object.keys(jobCounts).reduce((acc, key) => {
    // @ts-ignore
    acc[key] = ((jobCounts[key] / totalJobs) * 100).toFixed(2);
    return acc;
  }, {});

  return (
    <div data-cy="job-counts-bar">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          maxWidth: 100,
        }}
      >
        {Object.entries(jobPercentages).map(([status, percentage]) => (
          <div
            key={status}
            style={{
              width: `${percentage}%`,
              height: 10,
              // @ts-ignore
              backgroundColor: jobStatusColorMap[status],
              borderRight: '1px solid #fff',
            }}
          ></div>
        ))}
      </div>
      {Object.entries(jobCounts).map(([status, count]) => (
        <Typography
          key={status}
          data-cy={`job-count-${status}`}
          fontSize={12}
          variant="body2"
          // @ts-ignore
          color={jobStatusColorMap[status]}
        >
          {count} {statusTextMap?.[status] || capitalize(status)}
        </Typography>
      ))}
    </div>
  );
};

export default JobCountsBar;
